export default __webpack_public_path__ + "9de2c055caa54834fc7bcba2e27d73cb.png";